import { mapState } from 'vuex';
import ApiService from '@/services/apiService';
import { get } from 'lodash';
export default {
  name: 'DeviceTemplatesUnsyncedChanges',
  props: {
    template: {
      type: Object,
      required: true
    },
    hasUnsavedChanges: {
      type: Boolean,
      required: true
    },
    linkedDevicesTotalCount: {
      type: Number,
      required: true
    },
    unsyncedChanges: {
      type: Array,
      required: true,
      default: () => []
    },
    readonly: {
      type: Boolean,
      optional: true,
      default: false
    }
  },
  data() {
    return {
      allDevicesSynced: false,
      tableLoading: false,
      expanded: [],
      syncDialogOpen: false
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions']),
    tableLocalizations() {
      return {
        headers: [{
          sortable: false,
          text: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.modification'),
          value: 'modification'
        }, {
          sortable: false,
          text: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.valueBeforeSync'),
          value: 'valueBeforeSync'
        }, {
          sortable: false,
          text: this.$i18n_t('DigitalTwin.VirtualDevice.deviceTemplates.valueAfterSync'),
          value: 'valueAfterSync'
        }]
      };
    },
    promptButtons() {
      const buttons = [{
        text: this.$i18n_t('Common.cancel'),
        emit: 'cancel'
      }];
      if (this.hasUnsavedChanges) {
        buttons.push({
          text: this.$i18n_t('Common.saveAndSynchronise'),
          color: this.color,
          emit: 'saveAndSynchronise'
        });
      } else {
        buttons.push({
          text: this.$i18n_t('Common.synchronise'),
          color: this.color,
          emit: 'saveAndSynchronise',
          dataCy: 'save_and_synchronise'
        });
      }
      return buttons;
    },
    syncDisabled() {
      return this.linkedDevicesTotalCount === 0 || get(this.template, 'deviceSyncStatus.isRunning') || this.unsyncedChanges.length === 0 || this.readonly;
    }
  },
  methods: {
    async saveAndSynchronise() {
      try {
        await ApiService.deviceTemplatePublishAndSync(this.template);
        this.$snack(this.$i18n_t('DigitalTwin.VirtualDevice.snacks.syncStarted'), 'success');
      } catch (e) {
        this.$snack(this.$i18n_t('DigitalTwin.VirtualDevice.snacks.syncError'), 'error');
      }
      this.template = await ApiService.deviceTemplateGetByIdDraft(this.template.id);
      this.$emit('save-and-synchronise', this.template);
      this.syncDialogOpen = false;
    }
  }
};